<template>
  <section class="dp-layout">
    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
        <el-table
          :data="users"
          v-loading="listLoading"
          @select="dialogCheck"
          @row-click="selectCurrentRow"
          ref="table"
          style="width: 100%"
          class="custom-tbl"
          height="100%"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="RealCardNumber" label="真实卡号" width></el-table-column>
          <el-table-column prop="VirtualCardNumber" label="虚拟卡号" width></el-table-column>
          <el-table-column prop="CreateTime" label="添加时间" width></el-table-column>
          <el-table-column prop="ModifyTime" label="修改时间" width></el-table-column>
        </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          :page-size="10"
          :total="total"
          style="float: right"
        ></el-pagination>
      </el-col>

      <!--编辑界面-->
      <el-dialog
        title="编辑"
        :visible.sync="editFormVisible"
        v-model="editFormVisible"
        :close-on-click-modal="false"
        width="30%"
      >
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
          <el-form-item label="真实卡号" prop="RealCardNumber">
            <el-input v-model="editForm.RealCardNumber" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="虚拟卡号" prop="VirtualCardNumber">
            <el-input v-model="editForm.VirtualCardNumber" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog
        title="新增"
        :visible.sync="addFormVisible"
        v-model="addFormVisible"
        :close-on-click-modal="false"
        width="30%"
      >
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-form-item label="真实卡号" prop="RealCardNumber">
            <el-input v-model="addForm.RealCardNumber" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="虚拟卡号" prop="VirtualCardNumber">
            <el-input v-model="addForm.VirtualCardNumber" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 导入结果 -->
      <import-result-dialog
        :visible.sync="importResultVisible"
        :result="importResult"
      />

      <!-- 导入：选择文件（对齐人员导入规范）。创建于 2026-09-16 -->
      <el-dialog
        :visible.sync="importDialogVisible"
        width="860px"
        custom-class="person-import-dialog"
        :close-on-click-modal="false"
        append-to-body
        @closed="onImportDialogClosed"
      >
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-link"></i></span>
          <div>
            <strong>批量导入虚拟卡绑定</strong>
            <p>下载模板填写后上传，核对无误后再确认写入；真实卡与虚拟卡均须已在卡库中</p>
          </div>
        </div>
        <div class="pi-body">
          <div class="pi-steps">
            <div class="pi-step">
              <span class="pi-step__no">1</span>
              <div><strong>下载模板</strong><em>按列填写真实卡号 / 虚拟卡号</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">2</span>
              <div><strong>上传 Excel</strong><em>支持 .xlsx / .xls</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">3</span>
              <div><strong>核对导入</strong><em>预览后再确认写入</em></div>
            </div>
          </div>
          <button type="button" class="pi-template-card" @click="downloadImportTemplate">
            <span class="pi-template-card__icon"><i class="el-icon-document"></i></span>
            <span class="pi-template-card__meta">
              <strong>虚拟卡绑定导入模板.xlsx</strong>
              <em>含真实卡号、虚拟卡号两列；卡号不足 10 位导入时自动补 0</em>
            </span>
            <span class="pi-template-card__action"><i class="el-icon-download"></i>下载模板</span>
          </button>
          <el-upload
            :key="'card-binding-upload-' + importUploadKey"
            class="pi-upload"
            drag
            action="#"
            :auto-upload="false"
            :limit="1"
            :show-file-list="false"
            accept=".xlsx,.xls"
            :on-change="onImportFileChange"
            :on-remove="onImportFileRemove"
            :on-exceed="onImportExceed"
          >
            <div v-if="importFileRaw" class="pi-upload__file">
              <i class="el-icon-success pi-upload__ok"></i>
              <div>
                <strong>{{ importFileRaw.name }}</strong>
                <em>已选择，点击「解析并预览」</em>
              </div>
            </div>
            <div v-else class="pi-upload__empty">
              <i class="el-icon-upload2"></i>
              <strong>点击浏览或拖拽 Excel 到此处</strong>
              <em>仅支持 .xlsx / .xls</em>
            </div>
          </el-upload>
        </div>
        <div slot="footer" class="pi-footer">
          <el-button @click="importDialogVisible = false">关闭</el-button>
          <el-button
            type="primary"
            icon="el-icon-view"
            :disabled="!importFileRaw"
            :loading="importParsing"
            @click="parseImportFile"
          >
            解析并预览
          </el-button>
        </div>
      </el-dialog>

      <!-- 导入核对 -->
      <el-dialog
        :visible.sync="previewDialogVisible"
        :close-on-click-modal="false"
        width="78%"
        custom-class="person-import-dialog"
        append-to-body
        :before-close="(done) => { backToImportSelect(); done(); }"
      >
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
          <div>
            <strong>虚拟卡绑定导入核对</strong>
            <p>共 {{ importRows.length }} 条，确认无误后写入系统</p>
          </div>
        </div>
        <el-table
          :data="pagedImportRows"
          class="pi-preview-table"
          border
          stripe
          style="width: 100%"
          max-height="520"
        >
          <el-table-column type="index" label="序号" width="60" align="center" :index="previewIndexMethod" />
          <el-table-column prop="RealCardNumber" label="真实卡号" min-width="160" show-overflow-tooltip />
          <el-table-column prop="VirtualCardNumber" label="虚拟卡号" min-width="160" show-overflow-tooltip />
          <el-table-column fixed="right" label="操作" align="center" width="90">
            <template slot-scope="scope">
              <el-button type="text" class="pi-row-del" @click="removeImportRow(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="importRows.length > 10" class="pi-preview-pager">
          <el-pagination
            layout="total, sizes, prev, pager, next"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="previewPageSize"
            :current-page="previewPage"
            :total="importRows.length"
            @size-change="handlePreviewSizeChange"
            @current-change="handlePreviewCurrentChange"
          />
        </div>
        <div slot="footer" class="pi-footer">
          <el-button @click="backToImportSelect">返回上一步</el-button>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            :disabled="!importRows.length"
            :loading="importing"
            @click="submitImport"
          >
            确认导入
          </el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getCardBindingList,
  removeCardBinding,
  editCardBinding,
  addCardBinding,
  importCardBindingBatch,
  exportCardBinding,
} from "../../api/modules/personnel";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import ImportResultDialog from "../../components/ImportResultDialog";
import { normalizeImportBatchResponse } from "../../utils/importResultParser";
import { read, utils, writeFile } from "xlsx";
import "../../style/person-import-dialog.css";

export default {
  components: { Toolbar, ImportResultDialog },
  data() {
    return {
      filters: {
        name: "",
      },
      buttonList: [],
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      currentRow: null,
      editFormVisible: false,
      editLoading: false,
      editFormRules: {
        RealCardNumber: [{ required: true, message: "请输入真实卡号", trigger: "blur" }],
        VirtualCardNumber: [{ required: true, message: "请输入虚拟卡号", trigger: "blur" }],
      },
      editForm: {
        Id: 0,
        RealCardNumber: "",
        VirtualCardNumber: "",
      },
      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        RealCardNumber: [{ required: true, message: "请输入真实卡号", trigger: "blur" }],
        VirtualCardNumber: [{ required: true, message: "请输入虚拟卡号", trigger: "blur" }],
      },
      addForm: {
        RealCardNumber: "",
        VirtualCardNumber: "",
      },
      // 导入/导出
      importDialogVisible: false,
      previewDialogVisible: false,
      importResultVisible: false,
      importResult: null,
      importFileRaw: null,
      importUploadKey: 0,
      importParsing: false,
      importing: false,
      importKeepFileOnClose: false,
      importRows: [],
      previewPage: 1,
      previewPageSize: 10,
      exportLoading: false,
    };
  },
  computed: {
    /** 导入核对表格当前页数据。创建于 2026-09-16 */
    pagedImportRows() {
      const start = (this.previewPage - 1) * this.previewPageSize;
      return this.importRows.slice(start, start + this.previewPageSize);
    },
  },
  methods: {
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      const search = item && item.search;
      this.filters = {
        name: typeof search === "string" || search == null || search === undefined
          ? (search || "")
          : "",
      };

      const btnName = String((item && (item.name || item.Name)) || "").trim();
      // 导入/导出优先按按钮名称映射，避免权限 Func 配错导致点击无反应
      const nameMap = {
        导入: "ImportCensus",
        导出: "exportExcel",
        查询: "handleQuery",
        新增: "handleAdd",
        编辑: "handleEdit",
        删除: "handleDel",
      };
      let fnName = nameMap[btnName] || String((item && (item.Func || item.func)) || "").trim();
      const fn = fnName ? this[fnName] : null;
      if (typeof fn !== "function") {
        this.$message.error(`未找到操作方法：${fnName || btnName || "未知"}`);
        return;
      }
      return fn.call(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    /** 查询虚拟卡绑定列表 */
    handleQuery() {
      const para = {
        page: this.page,
        key: this.filters.name,
      };
      this.listLoading = true;
      getCardBindingList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },
    /** 删除选中绑定 */
    handleDel() {
      const row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          const para = { id: row.Id };
          removeCardBinding(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    /** 打开编辑 */
    handleEdit() {
      const row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    /** 打开新增 */
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        RealCardNumber: "",
        VirtualCardNumber: "",
      };
    },
    /** 提交编辑 */
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            const para = Object.assign({}, this.editForm);
            editCardBinding(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    /** 提交新增 */
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            const para = Object.assign({}, this.addForm);
            addCardBinding(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },

    // ---------- 导入 / 导出（对齐人员导入：浏览 → 预览 → 结果）----------

    /** 打开批量导入弹窗。创建于 2026-09-16 */
    ImportCensus() {
      this.resetImportDialog();
      this.importDialogVisible = true;
    },
    /**
     * 导出虚拟卡绑定（走后端 ExportCardBinding 接口）。
     * 全屏 loading 由全局 exportLoadingMixin 统一负责，勿再手动 $loading。最后更新：2026-11-02
     */
    async exportExcel() {
      try {
        const response = await exportCardBinding({
          key: this.filters.name || "",
        });
        if (!response || !response.data) {
          this.$message.error("导出数据为空");
          return;
        }

        // 若后端用 MessageModel JSON 包在 blob 里返回失败，避免当成 xlsx 下载
        const rawBlob = response.data;
        if (rawBlob instanceof Blob && rawBlob.type && rawBlob.type.indexOf("json") >= 0) {
          const text = await rawBlob.text();
          let msg = "导出失败";
          try {
            const j = JSON.parse(text);
            msg = (j && (j.msg || j.message)) || msg;
          } catch (e) {
            if (text) msg = text;
          }
          this.$message.error(msg);
          return;
        }

        const blob = new Blob([rawBlob], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "虚拟卡绑定.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        this.$message.success("导出成功");
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("虚拟卡绑定导出失败", e);
        if (!(e && e.bizMessage)) {
          this.$message.error((e && e.message) || "导出失败");
        }
      }
    },
    resetImportDialog() {
      this.importFileRaw = null;
      this.importParsing = false;
      this.importUploadKey += 1;
    },
    onImportDialogClosed() {
      if (this.importKeepFileOnClose) {
        this.importKeepFileOnClose = false;
        return;
      }
      this.resetImportDialog();
    },
    backToImportSelect() {
      this.previewDialogVisible = false;
      this.importDialogVisible = true;
    },
    onImportFileChange(file) {
      this.importFileRaw = file && file.raw ? file.raw : null;
    },
    onImportFileRemove() {
      this.importFileRaw = null;
    },
    onImportExceed(files) {
      const nextFile = files && files[0];
      if (!nextFile) return;
      this.importUploadKey += 1;
      this.$nextTick(() => {
        this.importFileRaw = nextFile;
      });
    },
    /** 下载导入模板。创建于 2026-09-16 */
    downloadImportTemplate() {
      const headers = ["真实卡号", "虚拟卡号"];
      const sample = ["3954487879", "7777777780"];
      const sheet = utils.aoa_to_sheet([headers, sample]);
      const book = utils.book_new();
      utils.book_append_sheet(book, sheet, "虚拟卡绑定");
      writeFile(book, "虚拟卡绑定导入模板.xlsx");
    },
    /** 解析 Excel 并进入核对。创建于 2026-09-16 */
    parseImportFile() {
      if (!this.importFileRaw) {
        this.$message.warning("请先浏览选择 Excel 文件");
        return;
      }
      const file = this.importFileRaw;
      if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传 xls 或 xlsx 格式");
        return;
      }
      this.importParsing = true;
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const workbook = read(ev.target.result, { type: "binary" });
          const ws = utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
            raw: false,
          });
          const rows = this.mapImportRows(ws);
          this.importParsing = false;
          if (!rows.length) {
            this.$message.warning("Excel 中未检测到有效的虚拟卡绑定记录");
            return;
          }
          this.importRows = rows;
          this.previewPage = 1;
          this.importKeepFileOnClose = true;
          this.importDialogVisible = false;
          this.$nextTick(() => {
            this.previewDialogVisible = true;
          });
        } catch (e) {
          this.importParsing = false;
          this.$message.error("文件读取失败");
        }
      };
      fileReader.onerror = () => {
        this.importParsing = false;
        this.$message.error("文件读取失败");
      };
      fileReader.readAsBinaryString(file);
    },
    /** 将 Excel 行映射为导入结构，过滤空行与示例说明行。创建于 2026-09-16 */
    mapImportRows(ws) {
      const temp = [];
      (ws || []).forEach((item) => {
        const realCard = String(
          item["真实卡号"] || item["RealCardNumber"] || item["真实卡"] || ""
        ).trim();
        const virtualCard = String(
          item["虚拟卡号"] || item["VirtualCardNumber"] || item["虚拟卡"] || ""
        ).trim();
        const combined = `${realCard}${virtualCard}`;
        if (!realCard && !virtualCard) return;
        if (combined.includes("示例") || /sample/i.test(combined)) return;
        temp.push({
          RealCardNumber: realCard,
          VirtualCardNumber: virtualCard,
        });
      });
      return temp;
    },
    previewIndexMethod(index) {
      return (this.previewPage - 1) * this.previewPageSize + index + 1;
    },
    handlePreviewSizeChange(val) {
      this.previewPageSize = val;
      this.previewPage = 1;
    },
    handlePreviewCurrentChange(val) {
      this.previewPage = val;
    },
    /** 从核对列表移除一行。创建于 2026-09-16 */
    removeImportRow(scope) {
      const idx = (this.previewPage - 1) * this.previewPageSize + scope.$index;
      const label = (scope.row && scope.row.RealCardNumber) || "该记录";
      this.$confirm(`确定要从本次导入中移除「${label}」吗？`, "提示", {
        type: "warning",
      })
        .then(() => {
          this.importRows.splice(idx, 1);
          if (this.pagedImportRows.length === 0 && this.previewPage > 1) {
            this.previewPage -= 1;
          }
          this.$message.success("已移除");
        })
        .catch(() => {});
    },
    /** 展示导入结果弹窗。创建于 2026-09-16 */
    showImportResult(resData) {
      this.importResult = (resData && resData.response) || null;
      this.importResultVisible = true;
      const normalized = normalizeImportBatchResponse(resData || {});
      if (!normalized.items.length) {
        const text = normalized.summary || (resData && resData.msg) || "";
        if (text) this.$message.success(text);
      }
    },
    /** 确认导入。创建于 2026-09-16 */
    submitImport() {
      if (!this.importRows.length) {
        this.$message.warning("没有要导入的数据");
        return;
      }
      this.importing = true;
      const loading = this.$loading({
        lock: true,
        text: "导入中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      importCardBindingBatch({ items: this.importRows })
        .then((res) => {
          loading.close();
          this.importing = false;
          if (res.data && res.data.success) {
            this.previewDialogVisible = false;
            this.showImportResult(res.data);
            this.handleQuery();
          } else {
            this.showImportResult(res.data || {});
            if (!this.importResult) {
              this.$message.error((res.data && res.data.msg) || "导入失败");
            }
          }
        })
        .catch(() => {
          loading.close();
          this.importing = false;
          this.$message.error("导入失败");
        });
    },
    /**
     * 补齐/纠正导入导出按钮 Func，避免权限里只有名称导致点击无反应。创建于 2026-09-16
     */
    ensureImportExportButtons() {
      const list = Array.isArray(this.buttonList) ? [...this.buttonList] : [];
      const findByFunc = (fn) =>
        list.find((b) => String(b.Func || b.func || "").trim() === fn);
      const findByName = (name) =>
        list.find((b) => String(b.name || b.Name || "").trim() === name);

      const importBtn = findByFunc("ImportCensus") || findByName("导入");
      if (!importBtn) {
        list.push({ name: "导入", Func: "ImportCensus", IsButton: true });
      } else if (String(importBtn.Func || importBtn.func || "").trim() !== "ImportCensus") {
        this.$set(importBtn, "Func", "ImportCensus");
      }

      const exportBtn = findByFunc("exportExcel") || findByName("导出");
      if (!exportBtn) {
        list.push({ name: "导出", Func: "exportExcel", IsButton: true });
      } else if (String(exportBtn.Func || exportBtn.func || "").trim() !== "exportExcel") {
        this.$set(exportBtn, "Func", "exportExcel");
      }

      this.buttonList = list;
    },
    /** 初始化工具栏按钮并纠正导入/导出 Func。创建于 2026-09-16 */
    initToolbarButtons() {
      const routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList(this.$route.path, routers);
      this.ensureImportExportButtons();
    },
  },
  mounted() {
    this.exportLoading = false;
    this.handleQuery();
    this.initToolbarButtons();
  },
  activated() {
    this.exportLoading = false;
    this.initToolbarButtons();
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
